import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { DatabaseIcon, JobIcon, ListIcon, MetadataIcon, VaartaIcon, MenuIcon } from '@/icons';
var menuItems = [
    {
        label: 'Database Connection',
        path: '/database-connection',
        icon: _jsx(DatabaseIcon, {}),
        matchedRoutes: ['/database-connection'],
    },
    {
        label: 'Metadata Selection',
        path: '/metadata-selection',
        icon: _jsx(MetadataIcon, {}),
        matchedRoutes: ['/metadata-selection', '/metadata-selection/details'],
    },
    {
        label: 'Job Scheduling',
        path: '/view-all-jobs',
        icon: _jsx(JobIcon, {}),
        matchedRoutes: ['/view-all-jobs', '/job-scheduling', '/view-logs'],
    },
    {
        label: 'Configured List',
        path: '/configured-list',
        icon: _jsx(ListIcon, {}),
        matchedRoutes: ['/configured-list'],
    },
];
export default function SidePanel(_a) {
    var onMenuClick = _a.onMenuClick, _b = _a.open, open = _b === void 0 ? true : _b, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c;
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var panelOpen = isMobile ? false : open;
    return (_jsxs("div", { className: "bg-white min-h-screen shadow-lg flex flex-col py-4 px-2 transition-all duration-300 z-10\n      ".concat(panelOpen ? 'w-64' : 'w-16'), children: [_jsx("div", { className: 'flex items-center justify-between mb-10 pl-0', children: panelOpen ? (_jsxs(_Fragment, { children: [_jsx("div", { className: 'flex items-center gap-2 text-xl font-bold text-primary', children: _jsx(VaartaIcon, {}) }), _jsx("button", { onClick: onMenuClick, className: 'p-2 rounded-md hover:bg-gray-100 cursor-pointer', children: _jsx(MenuIcon, { className: 'h-6 w-6 text-gray-800' }) })] })) : (_jsx("button", { onClick: isMobile ? undefined : onMenuClick, className: 'p-2 rounded-md hover:bg-gray-100 mx-auto cursor-pointer', disabled: isMobile, children: _jsx(MenuIcon, { className: 'h-6 w-6 text-gray-800 ' }) })) }), _jsx("nav", { className: 'flex flex-col gap-2', children: menuItems.map(function (item, idx) {
                    var _a, _b;
                    var isActive = (_b = (_a = item.matchedRoutes) === null || _a === void 0 ? void 0 : _a.some(function (route) { return pathname.startsWith(route); })) !== null && _b !== void 0 ? _b : pathname.startsWith(item.path);
                    return (_jsxs("button", { onClick: function () { return navigate(item.path); }, className: "flex items-center w-full text-left cursor-pointer ".concat(panelOpen ? 'gap-3 px-3 py-2' : 'justify-center p-2', " rounded-lg text-lg font-medium hover:bg-blue-600 hover:text-white ").concat(isActive ? 'bg-blue-200 text-blue-800' : 'text-blue-600'), children: [_jsx("span", { className: 'w-6 h-6', children: item.icon }), panelOpen && _jsx("span", { children: item.label })] }, idx));
                }) })] }));
}
